//导入两个文件
import en_US from './en_US';
import zh_CN from './zh_CN';
// import ar from './ar';
import zh_TC from './zh_TC';
export default {
  en_US: en_US,
  zh_CN: zh_CN,
  // ar: ar,
  zh_TC: zh_TC
}


// WEBPACK FOOTER //
// ./src/assets/i18n/langs/index.js